import { useEffect, useState } from "react";
import { ISerialNumberTableProps } from "../SelectDocumentInterfaces";
import "./css/SerialNumberTable.css";
import { BasicMachineInformationStruct } from "../../../common/Interfaces";
import { MaterialReactTable } from "material-react-table";
import SerialNumberColumns from "./SerialNumberColumns";
export default function SerialNumberTable({
  basicMachineInformationResults,
  onSelect,
}: ISerialNumberTableProps) {
  const [selectedRow, setSelectedRow] =
    useState<BasicMachineInformationStruct>();

  useEffect(() => {
    if (basicMachineInformationResults.length === 1) {
      setSelectedRow(basicMachineInformationResults[0]);
      onSelect(basicMachineInformationResults[0]);
    }
  }, [basicMachineInformationResults, onSelect]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState<string[]>([]);
  const [popupTitle, setPopupTitle] = useState("");
  const columns = SerialNumberColumns({
    setPopupContent,
    setShowPopup,
    setPopupTitle,
  });
  return (
    <div className="custom-table">
      <MaterialReactTable
        columns={columns}
        data={basicMachineInformationResults}
        enableHiding={false}
        enableDensityToggle={false}
        enableExpandAll={false}
        enableFullScreenToggle={false}
        enableGlobalFilterModes={false}
        initialState={{
          density: "compact",
        }}
        enableColumnActions={false}
        enableColumnFilters={false}
        enableBottomToolbar={false}
        enablePagination={false}
        enableRowVirtualization={true}
        positionActionsColumn="last"
        muiTableContainerProps={{
          sx: {
            maxHeight: 200,
          },
        }}
        muiTablePaperProps={{
          sx: {
            width: "100%",
          },
        }}
        layoutMode="grid"
        muiTableBodyRowProps={({ row }) => ({
          sx: {
            backgroundColor:
              selectedRow === row.original ? "#0079a133" : "inherit",
            cursor: "pointer",
          },
          onClick: () => {
            setSelectedRow(row.original);
            onSelect(row.original);
          },
        })}
      />
    </div>
  );
}
